import React, { useState } from "react";
import { Col, Modal, Row, Form } from "react-bootstrap";
// import { Form } from 'react-router-dom';
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import axios from "../../API/axios";
import Flatpickr from "react-flatpickr";
import moment from "moment";

const AddEducationActivity = ({
  getUserCv,
  userDataId,
  handleCloseEducationActivity,
  showEducationActivity,
  educationData,
}) => {
  const sessionId = localStorage.getItem("sessionId");
  const userType = localStorage.getItem("userType");
  const { CandidateId } = useParams();
  const [activity, setActivity] = useState("");
  const [display, setDisplay] = useState(false);
  console.log("educationData", educationData);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisplay(true);
    const body = {
      sessionId: sessionId,
      userDataId: userDataId,
      userType: userType,
      instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
      eduId: educationData.usrDataEductnId, 
      eduActvtyId: 0,
      activity: activity,
    };
    console.log("body====>", body);
    // if (achivement === "" || achivementDate === "") {
    //   toast.error("Please fill all the required fields");
    // } else {
    try {
      const res = await axios.post("/Resume/AddEducationActivity", body);
      toast.success(res.data.message);
      handleCloseEducationActivity();
      getUserCv();
      setActivity("");
      setDisplay(false);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        toast.warning(error.response.data.message);
      } else {
        toast.error(error.response?.data?.message || "An error occurred");
      }
    }
    // }
  };
  return (
    <Modal
      show={showEducationActivity}
      onHide={handleCloseEducationActivity}
      centered
      size="lg"
    >
      <Modal.Header>
        <Modal.Title>Add Education Activity</Modal.Title>
        <CloseSharpIcon
          className="pointer"
          onClick={handleCloseEducationActivity}
        />
      </Modal.Header>
      <Modal.Body className="settings">
        <Row>
          <Col md={12}>
            <Form.Group controlId="grade">
              <Form.Label className="class-type">
                Activity{" "}
                <span style={{ color: "red" }} className="ms-2">
                  *
                </span>
              </Form.Label>
              <Form.Control
                type="text"
                value={activity}
                onChange={(e) => setActivity(e.target.value)}
                placeholder="Enter Activity"
                className="Dark-Input-from-group"
              />
              {display && !activity ? (
                <span className="error_msg_lbl">Add Activity </span>
              ) : null}
            </Form.Group>
          </Col>
        </Row>

        <div className="d-flex justify-content-end mt-4">
          <div className="add-class-submit-button mt-4 d-flex justify-content-center">
            <div className="khojPrimaryBtn ms-3">
              <a href="#/" onClick={handleSubmit}>
                Submit
              </a>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddEducationActivity;
